<emperor-button
  [uiButtonType]="uiButtonTypes.Stroked"
  [color]="themeColors.PRIMARY"
  (click)="click()"
  [disabled]="buttonDisabled"
  >{{ text }}</emperor-button
>
